import { Marker as MapboxMarker } from "react-map-gl";
import { Flex, Image, Tooltip } from "@chakra-ui/react";
import { Coordinate, Spot } from "~/generated/graphql.types";
import { useState } from "react";
import { SpotOrderBadge } from "../../../../_shared/SpotOrderBadge";
import { SpotParamsFragment } from "~/routes/_shared/fragments.generated";
import { TrialDriveSpotFragment } from "~/routes/CourseDetail/index.generated";
import { TriangleDownIcon } from "@chakra-ui/icons";
import memoIcon from "./assets/memo_icon.svg";

export const TrialDriveSpotMarker = ({
  spot,
  onClick = () => {},
}: {
  spot: TrialDriveSpotFragment;
  onClick?: () => void;
}) => {
  return (
    <MapboxMarker
      data-testid={"trial-drive-spot-marker"}
      draggable={false}
      onClick={() => {
        onClick();
      }}
      latitude={spot.latitude}
      longitude={spot.longitude}
      style={{ zIndex: 100 }}
    >
      <Tooltip hasArrow label={spot.memo}>
        <Flex w={8} h={4}>
          <Image src={memoIcon} zIndex={-1} bottom={-2} position="absolute" />
        </Flex>
      </Tooltip>
    </MapboxMarker>
  );
};
